import React from "react";

export default function BridgeCenter() {
  return (
    <img src="/assets/odontogram/bridge-center.svg" alt="brigde-center"></img>
  );
}
